<script>
/**
 * 递归菜单项组件 — 替代硬编码 4 层嵌套，支持任意深度菜单
 */
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    item: { type: Object, required: true }
  },
  render(h, { props }) {
    const { item } = props
    const hasChildren = item.children && item.children.length > 0

    if (hasChildren) {
      return h('el-submenu', { props: { index: item.name }, key: item.id }, [
        h('template', { slot: 'title' }, [
          h('i', { class: item.icon }),
          h('span', item.title)
        ]),
        ...item.children.map(child =>
          h('MenuItem', { props: { item: child }, key: child.id })
        )
      ])
    }

    return h('el-menu-item', {
      props: { index: item.url || item.name },
      key: item.id
    }, [
      h('i', { class: item.icon }),
      h('span', item.title)
    ])
  }
}
</script>
